const normalizeText = (value = "") => String(value).toLowerCase().trim();

export const slugifyLocation = (value = "") =>
  normalizeText(value)
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/&/g, " and ")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

export const resolveLocationSlug = (location) =>
  slugifyLocation(location?.locationName || location?.title || location?.location || "");

export const matchesLocationParam = (location, value = "") => {
  const normalizedValue = normalizeText(value);

  if (!location || !normalizedValue) {
    return false;
  }

  return location?._id === value || resolveLocationSlug(location) === normalizedValue;
};

export const buildEditDetailsPath = (segment, location, form = "Overview") => {
  const slug = resolveLocationSlug(location) || location?._id || "item";
  return `/cms/${segment}/editdetails/${slug}${form ? `/${form}` : ""}`;
};

export const buildPreviewPath = (segment, location) => {
  const slug = resolveLocationSlug(location);
  return slug ? `/${segment}/${slug}` : "";
};
